/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section_7_Portability_DescInputs */

const en_privacy_section_7_portability_desc = /** @type {(inputs: Privacy_Section_7_Portability_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`request your data in a structured, machine-readable format`)
};

const lv_privacy_section_7_portability_desc = /** @type {(inputs: Privacy_Section_7_Portability_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pieprasīt Jūsu datus strukturētā, mašīnlasāmā formātā`)
};

/**
* | output |
* | --- |
* | "request your data in a structured, machine-readable format" |
*
* @param {Privacy_Section_7_Portability_DescInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const privacy_section_7_portability_desc = /** @type {((inputs?: Privacy_Section_7_Portability_DescInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section_7_Portability_DescInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_privacy_section_7_portability_desc(inputs)
	return en_privacy_section_7_portability_desc(inputs)
});